<template>
  <v-dialog
      :value="value"
      @input="$emit('input', $event)"
      max-width="600px">
    <v-card>
      <v-card-title class="text-center">
        <v-container>
          <v-row justify="center">
            <span class="headline">کلید فروشگاه</span>
          </v-row>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div>
                کلید زیر برای فروشگاه
                <strong>{{title}}</strong>
                ساخته شد. آن را در جایی امن برای خود
                ذخیره نمایید و از دسترس دیگران دور نگه دارید.
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  id="merchant-api-key"
                  readonly
                  class="ltr"
                  v-model="api_key"
                  solo>
                <template v-slot:append>
                  <v-btn class="me-2" icon color="success" @click="copyKey">
                    <v-icon class="mdi mdi-vector-arrange-above mdi-rotate-90"/>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="0" md="4">
            </v-col>
            <v-col cols="12" md="4">
              <v-btn @click="close()" color="success"
                     block>
                بسیار خب
              </v-btn>
            </v-col>
            <v-col cols="0" md="4">
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "DialogMerchantKey",
    props: [
      'value',
      'title',
      'api_key',
    ],
    data: () => ({}),
    methods: {
      close() {
        this.$emit('input', false)
      },
      copyKey: function() {
        const e = document.getElementById('merchant-api-key')
        e.select()
        e.setSelectionRange(0, this.api_key.length)

        this.$copyText(this.api_key).then(function () {
          e.setSelectionRange(0, 0)
        })

        this.$store.commit('showCopiedSnackbar')
      },
    },
  }
</script>

<style scoped>

</style>